export const colorPrimary = "#8FA225"; 
export const colorPrimaryDark = "#596423"; 
export const colorAccent = "#F28E1A"; 
export const colorPrimaryLight = "#DCEDC8";
export const colorTextPrimary = "#1D1D1B"; 
export const colorTextSecondary = "#757575"; 
export const colorLightGray = "#E0E0E0";
export const colorWhite = "white";
export const colorTextPrimaryWithAlpha = "#1d1d1b30";
export const colorPrimaryWithAlpha = "#8fa22540";

export const colorBlack = "#000000";
export const colorDarkGray = "#424242";
export const colorMaterialGrey = "#0000008a";
export const colorMaterialError = "#db2b2b";
export const colorAccentDark = "#dc7b0b";
export const colorMaterialDisabled = "#4e4e4e";
